(() => {
  const init = (root) => {
    if (!root || root.dataset.ffCarouselReady === 'true') return;
    const track = root.querySelector('[data-ff-carousel-track]');
    const prev = root.querySelector('[data-ff-carousel-prev]');
    const next = root.querySelector('[data-ff-carousel-next]');
    if (!track || !prev || !next) return;

    root.dataset.ffCarouselReady = 'true';
    track.setAttribute('tabindex', '0');

    const isActive = () => {
      const mq = root.dataset.ffCarouselMq;
      return !mq || window.matchMedia(mq).matches;
    };

    const step = () => {
      const card = track.querySelector('.ff-product-card');
      if (!card) return 0;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const update = () => {
      if (!isActive()) {
        track.scrollLeft = 0;
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };

    prev.addEventListener('click', () => {
      if (!isActive()) return;
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      if (!isActive()) return;
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev.click();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        next.click();
      }
    });
    window.addEventListener('resize', update);
    update();
  };

  const boot = (scope) => {
    (scope || document).querySelectorAll('[data-ff-carousel]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
